import { getStringVavlueFilterParamMap } from "../OYFilter/const";

/**
 * 将url中的query查询参数拼接成filter筛选器中的参数
 *
 * @param param
 * @param map
 */
export function mergeQueryParam(param: { [i: string]: any }, map = getStringVavlueFilterParamMap()) {
  const queryParam: any = {};
  $.each(map, (key, value) => {
    if (typeof value === 'string') {
      if (param[key] !== undefined) {
        queryParam[key] = param[key]
      }
    } else if ($.isPlainObject(value)) {
      const obj = mergeQueryParam(param, value);
      if (!$.isEmptyObject(obj)) {
        queryParam[key] = obj;
      }
    }
  })
  return queryParam;
}



// WEBPACK FOOTER //
// ./src/components/OYTool/filter.ts